import { selectStyle } from "Redux/appSlice";
import { useAppSelector } from "Redux/hooks";
import { TextElement } from "types/types";
import ExitButton from "../Atoms/ExitButton";
import Section from "../Atoms/TextSection";

export default function Term({
  title,
  text,
  index,
  onRemove,
  termId,
  setTerms,
}: {
  title: string;
  text: TextElement;
  index: number;
  onRemove: (index: number) => void;
  termId: string;
  setTerms: (id: string) => void;
}) {
  const { color2 } = useAppSelector(selectStyle);

  return (
    <div className="relative w-full" id={termId}>
      <div className="absolute right-10 top-0 lg:right-0 ">
        <ExitButton onClick={() => onRemove(index)} sizeOf="w-5 h-5" />
      </div>
      <h1 style={{ color: color2 }} className="mr-20 font-semibold lg:mr-5">
        {title}
      </h1>
      {text.map((t, i) => (
        <Section text={t} key={i} setTerms={setTerms} />
      ))}
    </div>
  );
}
